import { AudioTransport } from '../components/audio/AudioTransport';
import { ClipEditor } from '../components/audio/ClipEditor';
import { ClipTimeline } from '../components/audio/ClipTimeline';
import { RecordingPanel } from '../components/audio/RecordingPanel';
import { SampleInstruments } from '../components/audio/SampleInstruments';
import { SampleLibrary } from '../components/audio/SampleLibrary';
import { useAudioLibrary } from '../components/audio/useAudioLibrary';
import { ExportPanel } from '../components/music/ExportPanel';
import { ProviderStatusList } from '../components/ProviderStatusList';
import { Panel } from '../components/ui';

/** Audio production: sample library, sample instruments, clip timeline, editor, recording. */
export function AudioWorkspace() {
  const library = useAudioLibrary();
  return (
    <div className="flex flex-col gap-4">
      <AudioTransport />
      <ClipTimeline />
      <ClipEditor />
      <div className="grid gap-4 xl:grid-cols-2">
        <SampleLibrary library={library} />
        <div className="flex flex-col gap-4">
          <RecordingPanel library={library} />
          <SampleInstruments />
        </div>
      </div>
      <ExportPanel />
      <Panel title="Audio generation">
        <p className="mb-2 text-sm text-zinc-400">
          Text-to-audio and speech providers plug into a provider-neutral interface. None are configured, so these features are disabled and nothing is ever
          sent over the network.
        </p>
        <ProviderStatusList kinds={['text-to-audio', 'speech']} />
      </Panel>
    </div>
  );
}
